import { render, staticRenderFns } from "./WorkPlaceTranslate.vue?vue&type=template&id=6702df19&scoped=true"
import script from "./WorkPlaceTranslate.vue?vue&type=script&lang=js"
export * from "./WorkPlaceTranslate.vue?vue&type=script&lang=js"
import style0 from "./WorkPlaceTranslate.vue?vue&type=style&index=0&id=6702df19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6702df19",
  null
  
)

export default component.exports